import { adminHttpClient } from '../../commons/adminHttpClient'

const cancelRunout = (planPeriodId: string): Promise<any> => {
  return adminHttpClient.post('/csi/Companies/Benefit/CancelRunout', { planPeriodId: planPeriodId })
}

export default cancelRunout
